export const AUTH = 'AUTH';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const LOGIN = 'LOGIN';
export const CLEAR_LOGGED_IN = 'CLEAR_LOGGED_IN';
export const IS_SEAMLESS = 'IS_SEAMLESS';
